/*************************
 *
 *  AlpineJS
 *
 *********************** */
// import Alpine from 'alpinejs';

// window.Alpine = Alpine;

// Alpine.start();

/*************************
 *
 *  jQuery
 *
 *********************** */
if (typeof jQuery !== 'undefined') {
	window.$ = window.jQuery = $ = jQuery.noConflict();
}

$(document).ready(function ($) {
	var timelineCarousel = $('.timeline-carousel').owlCarousel({
		loop: true,
		mouseDrag: false,
		margin: 32,
		nav: false,
		dots: false,
		slideBy: 3,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 2,
			},
			1000: {
				items: 3,
			},
		},
	});

	$('.custom-prev-arrow').click(function () {
		timelineCarousel.trigger('prev.owl.carousel', [300]);
	});

	$('.custom-next-arrow').click(function () {
		timelineCarousel.trigger('next.owl.carousel', [300]);
	});
});
$(document).ready(function ($) {
	var timelineCarousel = $('.year-carousel').owlCarousel({
		loop: true,
		mouseDrag: false,
		margin: 32,
		nav: false,
		dots: false,
		slideBy: 3,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 2,
			},
			1000: {
				items: 3,
			},
		},
	});

	$('.custom-prev-arrow').click(function () {
		timelineCarousel.trigger('prev.owl.carousel', [300]);
	});

	$('.custom-next-arrow').click(function () {
		timelineCarousel.trigger('next.owl.carousel', [300]);
	});
});

jQuery(document).ready(function ($) {
	if ($('.owl-carousel').length) {
		$('.owl-carousel').owlCarousel({
			loop: true,
			mouseDrag: false,
			margin: 32,
			nav: false,
			dots: false,
			slideBy: 3,
			responsive: {
				0: {
					items: 1,
				},
				600: {
					items: 2,
				},
				1000: {
					items: 3,
				},
			},
		});

		$('.custom-prev-arrow').click(function () {
			yearCarousel.trigger('prev.owl.carousel', [300]);
		});

		$('.custom-next-arrow').click(function () {
			yearCarousel.trigger('next.owl.carousel', [300]);
		});
	}
});

// Call to action block topic switcher
document.addEventListener('DOMContentLoaded', function () {
	const topics = document.querySelectorAll('.topic');

	if (topics.length > 0) {
		let currentTopicIndex = 0;

		function showNextTopic() {
			const currentTopic = topics[currentTopicIndex];
			const nextTopicIndex = (currentTopicIndex + 1) % topics.length;
			const nextTopic = topics[nextTopicIndex];

			currentTopic.classList.add('exiting');
			setTimeout(() => {
				currentTopic.classList.remove('active', 'exiting');
				nextTopic.classList.add('active');
			}, 300);

			currentTopicIndex = nextTopicIndex;
		}

		topics[0].classList.add('active');
		setInterval(showNextTopic, 3000);
	}
});

//navigation
// Logo animation
const nav = document.getElementById('nav-hover');
const logoContainer = document.querySelector('.logo-container');
const logoText = document.querySelector('.logo-text');
const letters = document.querySelectorAll('.letter');

function setLetterStyles(opacity, transform, delays) {
	letters.forEach((letter, index) => {
		letter.style.transition = `opacity 0.3s ${delays[index]}s, transform 0.3s ${delays[index]}s`;
		letter.style.opacity = opacity;
		letter.style.transform = transform;
	});
}

// Hide logo text and letters by default
function hideLogoText() {
	logoText.style.opacity = '0';
	setLetterStyles('0', 'translateY(-20px)', [0, 0, 0, 0, 0]);
}

// Call this function on page load
hideLogoText();

// Animate letters only on hover
logoContainer.addEventListener('mouseenter', () => {
	logoText.style.opacity = '1';
	const delays = [0.4, 0.3, 0.2, 0.1, 0];
	setLetterStyles('1', 'translateY(0)', delays);
});

// Scroll event listener
window.addEventListener('scroll', function () {
	if (window.scrollY > 50) {
		nav.classList.add('scrolled');
		hideLogoText();
	} else {
		nav.classList.remove('scrolled');
		hideLogoText();
	}
});

logoContainer.addEventListener('mouseleave', () => {
	logoText.style.opacity = '0';

	requestAnimationFrame(() => {
		letters.forEach((letter, index) => {
			letter.style.transition = `transform 0.3s ease ${index * 0.05}s`;
			letter.style.transform = 'translateY(-20px)';
		});
	});
});

// Open and Close Submenu
(function () {
	function initializeNavigation() {
		function handleMenuClicks(e) {
			const button = e.target.closest('.menu-item-has-children > button');
			if (button) {
				e.preventDefault();
				e.stopPropagation();

				const menuItem = button.closest('.menu-item-has-children');
				const subMenu = menuItem.querySelector('.sub-menu');
				const svg = button.querySelector('svg');

				if (!subMenu) {
					console.warn('Submenu not found for:', button);
					return;
				}

				const isOpen = button.getAttribute('aria-expanded') === 'true';

				if (isOpen) {
					subMenu.style.display = 'none';
					svg.classList.remove('rotate-180');
					button.setAttribute('aria-expanded', 'false');
					menuItem.classList.remove('active');
				} else {
					subMenu.style.display = 'block';
					svg.classList.add('rotate-180');
					button.setAttribute('aria-expanded', 'true');
					menuItem.classList.add('active');
				}
			}
		}

		document.body.addEventListener('click', handleMenuClicks);
	}

	// Make sure we only attach the event listeners once
	document.addEventListener('DOMContentLoaded', function () {
		if (window.__NAV_INITIALIZED__) {
			return;
		}

		initializeNavigation();
		window.__NAV_INITIALIZED__ = true;
	});

	// Handle page cache restoration on back/forward navigation
	window.addEventListener('pageshow', function (event) {
		if (event.persisted && !window.__NAV_INITIALIZED__) {
			initializeNavigation();
			window.__NAV_INITIALIZED__ = true;
		}
	});
})();

document.addEventListener('DOMContentLoaded', function () {
	const subMenus = document.querySelectorAll('.sub-menu');
	const buttons = document.querySelectorAll('.menu-item-has-children > button');

	// Ensure all submenus are hidden and aria-expanded is set to false on load
	subMenus.forEach(function (subMenu) {
		subMenu.style.display = 'none';
	});

	buttons.forEach(function (button) {
		button.setAttribute('aria-expanded', 'false');
	});
});

// Dropdown menu right screen slide
document.addEventListener('DOMContentLoaded', function () {
	const navHover = document.getElementById('nav-hover');
	const hamburgerIcon = document.getElementById('hamburger-icon');
	const hamburgerIconMobile = document.getElementById('hamburger-icon-mobile');
	const closeIcon = document.getElementById('close-icon');
	const closeIconMobile = document.getElementById('close-icon-mobile');
	const menuContainer = document.querySelector('.menu-container');
	const menuContainerMobile = document.querySelector('.menu-container-mobile');
	const navOpenedMobile = document.querySelector('.nav-opened-mobile');
	const currentPageTitles = document.querySelectorAll('.current-page-title');

	// Dropdown functionality using event delegation
	document.addEventListener('click', function (e) {
		const link = e.target.closest('.menu-item-has-children > a');
		if (link) {
			e.preventDefault();
			e.stopPropagation();
			const menuItem = link.parentElement;
			const subMenu = menuItem.querySelector('.sub-menu');
			const svg = link.querySelector('svg');

			// Close all other open submenus
			document.querySelectorAll('.menu-item-has-children.active').forEach((item) => {
				if (item !== menuItem) {
					item.classList.remove('active');
					item.querySelector('.sub-menu').style.display = 'none';
					item.querySelector('a > svg')?.classList.remove('rotate-180');
					item.querySelector('a').setAttribute('aria-expanded', 'false');
				}
			});

			// Toggle the clicked submenu
			const isOpen = menuItem.classList.contains('active');
			menuItem.classList.toggle('active');
			subMenu.style.display = isOpen ? 'none' : 'block';
			svg?.classList.toggle('rotate-180');
			link.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
		}
	});

	// Close submenus when clicking outside
	document.addEventListener('click', function (e) {
		if (!e.target.closest('.menu-item-has-children')) {
			document.querySelectorAll('.menu-item-has-children.active').forEach((item) => {
				item.classList.remove('active');
				item.querySelector('.sub-menu').style.display = 'none';
				item.querySelector('a > svg')?.classList.remove('rotate-180');
				item.querySelector('a').setAttribute('aria-expanded', 'false');
			});
		}
	});

	// Scroll functionality
	window.addEventListener('scroll', function () {
		if (window.scrollY > 150) {
			navHover.classList.add('scrolled');
			currentPageTitles.forEach((title) => {
				title.style.display = 'flex';
				title.style.setProperty('display', 'flex', 'important');
			});
		} else {
			navHover.classList.remove('scrolled');
			currentPageTitles.forEach((title) => {
				title.style.display = 'none';
				title.style.setProperty('display', 'none', 'important');
			});
		}
	});

	// Mobile detection
	function isMobile() {
		return window.innerWidth <= 767;
	}

	// Menu toggle functionality
	hamburgerIcon.addEventListener('click', function () {
		if (!isMobile()) {
			menuContainer.style.display = 'block';
			menuContainer.classList.add('visible');
		}
	});

	hamburgerIconMobile.addEventListener('click', function () {
		if (isMobile()) {
			menuContainerMobile.style.display = 'block';
			navOpenedMobile.style.top = '0px';
			menuContainerMobile.classList.add('visible');
		}
	});

	closeIcon.addEventListener('click', function () {
		if (!isMobile()) {
			menuContainer.classList.remove('visible');
		}
	});

	closeIconMobile.addEventListener('click', function () {
		if (isMobile()) {
			menuContainerMobile.classList.remove('visible');
			navOpenedMobile.style.top = '32px';
			menuContainerMobile.style.display = 'none';
			// setTimeout(() => {
			// 	menuContainerMobile.style.display = 'none';
			// }, 300);
		}
	});

	// Handle resize events
	window.addEventListener('resize', function () {
		if (!isMobile()) {
			menuContainerMobile.style.display = 'none';
			menuContainerMobile.classList.remove('visible');
		} else {
			menuContainer.classList.remove('visible');
		}
	});

	// Add role attribute to main menu
	document.querySelectorAll('ul.main-menu').forEach((menu) => {
		menu.setAttribute('role', 'list');
	});
});

//navigation injecting role attribute
document.addEventListener('DOMContentLoaded', function () {
	var mainMenus = document.querySelectorAll('ul.main-menu');
	mainMenus.forEach(function (menu) {
		menu.setAttribute('role', 'list');
	});
});

//video sound option for heros
document.addEventListener('DOMContentLoaded', function () {
	var videoContainer = document.querySelector('.video-container');
	var playerContainer = document.getElementById('vimeo-player'); // Corrected to reference the actual iframe element
	var soundToggle = document.getElementById('sound-toggle');
	var isMuted = true;
	var player;

	function loadVimeoPlayer() {
		player = new Vimeo.Player(playerContainer, {
			url: '<?php echo esc_url($embed_url); ?>',
			background: true,
			autoplay: true,
			loop: true,
			muted: true,
			controls: false,
		});

		player
			.ready()
			.then(function () {
				player
					.play()
					.then(function () {
						setTimeout(function () {
							videoContainer.classList.add('video-loaded');
						}, 100);
					})
					.catch(function (error) {
						console.error('Error playing video:', error);
					});
				setupSoundToggle();
			})
			.catch(function (error) {
				console.error('Error setting up Vimeo player:', error);
			});
	}

	function setupSoundToggle() {
		if (soundToggle) {
			soundToggle.addEventListener('click', function () {
				if (isMuted) {
					player
						.setVolume(1)
						.then(function () {
							isMuted = false;
							soundToggle.classList.add('sound-on');
						})
						.catch(function (error) {
							console.error('Error setting volume:', error);
						});
				} else {
					player
						.setVolume(0)
						.then(function () {
							isMuted = true;
							soundToggle.classList.remove('sound-on');
						})
						.catch(function (error) {
							console.error('Error setting volume:', error);
						});
				}
			});
		}
	}

	// Lazy load the Vimeo player when the video container is in view
	if (videoContainer) {
		var observer = new IntersectionObserver(
			function (entries) {
				if (entries[0].isIntersecting) {
					loadVimeoPlayer();
					observer.disconnect();
				}
			},
			{ threshold: 0.1 }
		);

		observer.observe(videoContainer);
	}
});
